import { CoatingBM } from 'src/types/BusinessModel/Stowage/Product/CoatingBM';
import { Coating } from 'src/types/ViewModel/Vessel/Coating';

export const createCoating = (coatingBM: CoatingBM): Coating => {
    return {
        id: coatingBM.id,
        name: coatingBM.name,
        type: coatingBM.type,
    };
};

export const createCoatingList = (list: CoatingBM[]) => list.map((coatingBM) => createCoating(coatingBM));
